import type {SearchParams, ViewableSearch} from 'src/typings';
import type {SearchDataService} from './search.data-service';
import type {LogService} from 'core/logging/log.service';
import {resolveErrorMessage} from 'shared/utils/error-utils';
import {omitPropertiesBy} from 'shared/utils/object-utils';
import {exists, isNull} from 'shared/utils/custom-utils';
import {isString} from 'shared/utils/string-utils';

export class SearchService {

    public static serviceName = 'searchService';
    private readonly EXPORTS_PARAM = 'portaroSearchItemParagraph,portaroSearchItemMoreParagraph';
    private readonly DYNAMIC_FIELD_PREFIX = 'field_'

    /*@ngInject*/
    constructor(private searchDataService: SearchDataService, private logService: LogService) {
    }

    public async search<T, PARAMS extends SearchParams = SearchParams>(params: PARAMS): Promise<ViewableSearch<SearchParams, T>> {
        const defaultParams = {exports: this.EXPORTS_PARAM};
        try {
            return this.searchDataService.search({...defaultParams, ...this.filterParams(params)});
        } catch (err) {
            this.logService.error(resolveErrorMessage(err));
            throw err;
        }
    }

    private filterParams<PARAMS extends SearchParams = SearchParams>(params: PARAMS) {
        return omitPropertiesBy(params, (value, key) => !this.isValidParameter(key, value));
    }

    private isValidParameter<PARAMS extends SearchParams = SearchParams>(paramName: keyof PARAMS, paramValue: PARAMS[keyof PARAMS]): boolean {
        return exists(paramValue) || (this.isDynamicField(paramName) && isNull(paramValue));
    }

    private isDynamicField<PARAMS extends SearchParams = SearchParams>(paramName: keyof PARAMS) {
        return isString(paramName) && paramName.startsWith(this.DYNAMIC_FIELD_PREFIX);
    }
}